import { useMutation, useQueryClient } from "@tanstack/react-query";
import postsAPI from "../../api/posts/api";

export function useCreatePost() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postsAPI.createPost,
    onSuccess: () => {
      // Invalidate and refetch posts list
      queryClient.invalidateQueries({ queryKey: ["posts"] });
    },
    onError: (error) => {
      console.error("Create post failed:", error);
    },
  });
}
